export const AppConfig = {
    center: [45.20, 17.00],
    zoom: 8,
    activeLayer: "allum_project:hr_settlements_1910",
    colorRamp: "custom",
    colorRamps: {
        "custom": {
            name: "custom",
            colors: ["#ffffff", "#ffffff"]
        },
        "WhiteBlack": {
            name: "WhiteBlack",
            colors: ["#ffffff", "#000000"]
        },
        "WhiteRed": {
            name: "WhiteRed",
            colors: ["#ffffff", "#ff0000"]
        },
        "terrain": {
            name: "terrain",
            colors: ["#11FFA5", "#23FF00", "#F2F910", "#F9A810", "#553905"]
        },
        "colrampgrid": {
            name: "colrampgrid",
            colors: ["#2892C6", "#6CA9B3", "#9FC29A", "#CFDF7E", "#FAFB61", "#FBC15C", "#FA8C36", "#F7561F", "#FF0000", "#A70003"]
        },
        "colramp05": {
            name: "colramp05",
            colors: ["#2892C6","#80B4A8","#BFD38B","#F8F865","#FCB344","#F66D2F","#A80000"]
        },
        "colramp06": {
            name: "colramp06",
            colors: ["#E70000","#FB6D26","#FFB241","#FBFA60","#C0D387","#83B2AA","#2592CD"]
        },
        "colramp07": {
            name: "colramp07",
            colors: ["#F1F1A2","#FFFD38","#FC8100","#F505A6","#8B14E0","#0D1CAE"]
        },
        "colramp08": {
            name: "colramp08",
            colors: ["#FDFF79","#A1F24B","#36E108","#3FB768","#1B93AC","#204B90","#0E1075"]
        },
        "colramp09": {
            name: "colramp09",
            colors: ["#FFFFBD","#FFFF01","#FED47F","#F2A82F","#C56D19","#963A0B","#000000"]
        },
        "colramp10": {
            name: "colramp10",
            colors: ["#FFFFFF","#849EBC","#C0CABE","#FFFE70","#FFD47A","#FD5601","#D6311F","#B63200"]
        },
        "colramp11": {
            name: "colramp11",
            colors: ["#FFFFFF","#66B9FE","#65FFE1","#A2FF78","#FDFF02","#FBCC8C","#F69572","#EF0000","#AC0006"]
        },
        "colramp12": {
            name: "colramp12",
            colors: ["#006300","#538E17","#A5C30A","#FFFE03","#FFBA09","#FF7500","#E50007"]
        },
        "colramp13": {
            name: "colramp13",
            colors: ["#00B089","#80B3AD","#BCD185","#F9FA69","#F9AF44","#F86F1F","#EA1214"]
        },
        "colramp14": {
            name: "colramp14",
            colors: ["#FFFFFF","#86B1A9","#BFCE93","#F9F96E","#FFAC4E","#EE7132","#EF1301"]
        },
        "colramp15": {
            name: "colramp15",
            colors: ["#FFFFFF","#FC0100","#FF9C3D","#FED967","#FFFA06","#AACA91","#6BADAC","#0084AD"]
        }
    },
    activeField: "c_1",
    styleData: { colorRamp: ["#000000", "#ffffff"], breaks: [] },
    layerOptions: [
        {
            name: "Settlements 1785",
            layerId: "allum_project:hr_settlements_1785"
        },
        {
            name: "Settlements 1828",
            layerId: "allum_project:hr_settlements_1828"
        },
        {
            name: "Settlements 1910",
            layerId: "allum_project:hr_settlements_1910"
        },
    ],
    layers: {
        'allum_project:hr_settlements_1785': {
            "type": "WMS",
            "id": "allum_project:hr_settlements_1785",
            "active": false,
            "url": "http://193.225.239.5/geoserver/allum_project/wms",
            "name": "Settlements 1785",
            "sortOrder": 4,
            "minZoom": 0,
            "showLegend": true,
            "showInLayerList": false,
            "choloplethFields": [
                "c_t007",
                "c_t014",
                "c_t015",
                "c_t016",
                "c_t017",
                "c_t018",
                "c_t019",
                "c_t020",
                "c_t022",
                "c_t023",
                "c_t024",
                "c_t025",
                "c_t026",
                "c_t027",
                "c_t028",
                "c_t029",
                "c_t030",
                "c_t031",
                "c_t032",
                "c_t033",
                "c_t034",
                "c_t035",
                "c_t036",
                "c_t046",
                "c_t047",
                "c_t048",
                "c_t055",
                "c_t056",
                "c_t057",
                "c_t058",
                "c_t059",
                "c_t060",
                "c_t061",
                "c_t062",
                "c_t063"
            ],
            "fieldStyles": {
                "range": [
                    "c_t014",
                    "c_t015",
                    "c_t016",
                    "c_t017",
                    "c_t018",
                    "c_t019",
                    "c_t020",
                    "c_t022",
                    "c_t023",
                    "c_t024",
                    "c_t025",
                    "c_t026",
                    "c_t027",
                    "c_t028",
                    "c_t029",
                    "c_t030",
                    "c_t031",
                    "c_t032",
                    "c_t033",
                    "c_t034",
                    "c_t035",
                    "c_t036",
                    "c_t046",
                    "c_t047",
                    "c_t048",
                    "c_t055",
                    "c_t056",
                    "c_t057",
                    "c_t058",
                    "c_t059",
                    "c_t061",
                    "c_t062",
                    "c_t063"
                ],
                "categorical": [
                    "c_t007",
                    "c_t060"
                ]
            },
            "sldBody": null
        },
        'allum_project:hr_settlements_1828': {
            type: 'WMS',
            id: 'allum_project:hr_settlements_1828',
            active: false,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: 'Settlements 1828',
            sortOrder: 2,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "c_k009",
                "c_k010",
                "c_k011",
                "c_k012",
                "c_k013",
                "c_k014",
                "c_k015",
                "c_k016",
                "c_k017",
                "c_k037",
                "c_k038",
                "c_k039",
                "c_k040",
                "c_k041",
                "c_k042",
                "c_k043",
                "c_k044",
                "c_k045",
                "c_k046",
                "c_k047",
                "c_k048",
                "c_k049",
                "c_k050",
                "c_k051",
                "c_k054",
                "c_k055",
                "c_k056",
                "c_k057",
                "c_k058",
                "c_k059",
                "c_k060",
                "c_k068",
                "c_k069",
                "c_k070",
                "c_k071",
                "c_k072",
                "c_k073",
                "c_k074",
                "c_k075",
                "c_k076",
                "c_k077",
                "c_k078",
                "c_k079",
                "c_k080",
                "c_k081",
                "c_k082",
                "c_k087",
                "c_k088",
                "c_k089",
                "c_k090",
                "c_k091",
                "c_k092",
                "c_k093",
                "c_k094",
                "c_k095",
                "c_k096",
                "c_k097",
                "c_k098",
                "c_k099",
                "c_k110",
                "c_k111",
                "c_k112",
                "c_k113",
                "c_k114",
                "c_k115",
                "c_k116",
                "c_k117",
                "c_k118",
                "c_k119"
            ],
            fieldStyles: {
                "range": [
                "c_k009",
                "c_k010",
                "c_k011",
                "c_k012",
                "c_k013",
                "c_k014",
                "c_k015",
                "c_k016",
                "c_k017",
                "c_k037",
                "c_k038",
                "c_k039",
                "c_k040",
                "c_k041",
                "c_k042",
                "c_k043",
                "c_k044",
                "c_k045",
                "c_k046",
                "c_k047",
                "c_k048",
                "c_k049",
                "c_k050",
                "c_k051",
                "c_k054",
                "c_k055",
                "c_k056",
                "c_k057",
                "c_k058",
                "c_k059",
                "c_k060",
                "c_k068",
                "c_k069",
                "c_k070",
                "c_k071",
                "c_k072",
                "c_k073",
                "c_k074",
                "c_k075",
                "c_k076",
                "c_k077",
                "c_k078",
                "c_k079",
                "c_k080",
                "c_k081",
                "c_k082",
                "c_k087",
                "c_k088",
                "c_k089",
                "c_k090",
                "c_k091",
                "c_k092",
                "c_k093",
                "c_k094",
                "c_k095",
                "c_k096",
                "c_k097",
                "c_k098",
                "c_k099",
                "c_k110",
                "c_k111",
                "c_k112",
                "c_k113",
                "c_k114",
                "c_k115",
                "c_k116",
                "c_k117",
                "c_k118",
                "c_k119"
                ],
                "categorical": []
            },
            sldBody: null
        },        
        'allum_project:hr_settlements_1910': {
            type: 'WMS',
            id: 'allum_project:hr_settlements_1910',
            active: true,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: 'Settlements 1910',
            sortOrder: 2,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            choloplethFields: [
                "c_1",
                "c_2",
                "c_3",
                "c_4",
                "c_5",
                "c_6",
                "c_7",
                "c_8",
                "c_9",
                "c_10",
                "c_11",
                "c_12",
                "c_15",
                "c_16",
                "c_17",
                "c_18",
                "c_19",
                "c_20",
                "c_21",
                "c_22",
                "c_23",
                "c_24",
                "c_25",
                "c_26",
                "c_27",
                "c_28",
                "c_29",
                "c_30",
                "c_31",
                "c_32",
                "c_33",
                "c_34",
                "c_35",
                "c_36",
                "c_37",
                "c_38",
                "c_39",
                "c_40",
                "c_41",
                "c_42",
                "c_43",
                "c_44",
                "c_45",
                "c_46",
                "c_47",
                "c_48",
                "c_49",
                "c_51",
                "c_52",
                "c_53",
                "c_54",
                "c_55",
                "c_56",
                "c_57",
                "c_58"
            ],
            fieldStyles: {
                "range": [
                    "c_1",
                    "c_2",
                    "c_3",
                    "c_4",
                    "c_5",
                    "c_6",
                    "c_7",
                    "c_8",
                    "c_9",
                    "c_10",
                    "c_11",
                    "c_12",
                    "c_13",
                    "c_14",
                    "c_15",
                    "c_16",
                    "c_17",
                    "c_18",
                    "c_19",
                    "c_20",
                    "c_21",
                    "c_22",
                    "c_23",
                    "c_24",
                    "c_25",
                    "c_26",
                    "c_27",
                    "c_28",
                    "c_29",
                    "c_30",
                    "c_31",
                    "c_32",
                    "c_33",
                    "c_34",
                    "c_35",
                    "c_36",
                    "c_37",
                    "c_38",
                    "c_39",
                    "c_40",
                    "c_41",
                    "c_42",
                    "c_43",
                    "c_44",
                    "c_45",
                    "c_46",
                    "c_47",
                    "c_48",
                    "c_49",
                    "c_50",
                    "c_51",
                    "c_52",
                    "c_53",
                    "c_54",
                    "c_55",
                    "c_56",
                    "c_57",
                    "c_58"
                ],
                "categorical": []
            },
            sldBody: null
        },
        'allum_project:basemap': {
            type: 'BASE',
            id: 'allum_project:SRTM90_4326,allum_project:allut_lines,allum_project:kozlut_lines,allum_project:megyeiut_lines,allum_project:vasutallomas,allum_project:vasutvonal,allum_project:kikoto,allum_project:folyokl,allum_project:hr_jaras,allum_project:hr_jaras_1785,allum_project:jarasgeo1912,allum_project:hr1912,allum_project:hr_1785,allum_project:hr_megye,allum_project:hr_megye_1785,allum_project:country_borders_2016,allum_project:folyokm,allum_project:tavak',
            active: true,
            url: 'http://193.225.239.5/geoserver/allum_project/wms',
            name: 'Basemap',
            sortOrder: 10,
            minZoom: 0,
            showLegend: true,
            showInLayerList: false,
            opacity: 0.9
        },
    },
    enabledBmaps: [
    "allum_project:allut_lines",
    "allum_project:kozlut_lines",
    "allum_project:megyeiut_lines",
    "allum_project:postautak1808",
    "allum_project:vasutvonal",
    "allum_project:folyokl",
    "allum_project:hr_jaras",
    "allum_project:jarasgeo1912",
    "allum_project:hr1912",
    "allum_project:hr_megye",
    "allum_project:country_borders_2016",
    "allum_project:folyokm",
    "allum_project:tavak",
    "allum_project:vasutallomas",
    "allum_project:kikoto"
]
}

// ---- Feature flags (non-invasive) ----
export const FEATURES = {
      dualLayerMode: true // PROD: false. Teszthez állítsd true-ra vagy URL flaggel kezeld.
    };